import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {TranslateModule} from "@ngx-translate/core";

import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {TableModule} from 'primeng/table';
import { SkeletonModule } from 'primeng/skeleton';
import {ProgressBarModule} from 'primeng/progressbar';

import {MapService} from '@commons/services/map/map/map.service';

import {SharedModule} from "@shared/shared.module";

import {CommonsModule} from '../commons/commons.module';
import {MapComponent} from './map.component';
import {MapMainLayerComponent} from './main-layer/map-main-layer.component';
import {MapControlsComponent} from './controls/map-controls.component';
import {IconComponent} from './icon/icon.component';
import { MinimapControlsComponent } from './minimap-controls/minimap-controls.component';
import { ModalWithParkInformationComponent } from './components/modal-with-park-information/modal-with-park-information.component';
import { PipesModule } from '@commons/pipes/pipes.module';
import { LoaderMapComponent } from './components/loader-map/loader-map.component';
import { ModalEventInformationComponent } from './components/modal-event-information/modal-event-information.component';
import { ListVehicleBottomComponent } from './components/list-vehicle-bottom/list-vehicle-bottom.component';
import { CalculateTimeComponent } from './components/list-vehicle-bottom/calculate-time/calculate-time.component';
import { CalculateSpeedComponent } from './components/list-vehicle-bottom/calculate-speed/calculate-speed.component';
import { ETollStatusComponent } from './components/list-vehicle-bottom/e-toll-status/e-toll-status.component';
import { SingalStatusComponent } from './components/list-vehicle-bottom/gps-status/gps-status.component';
import { FuelStatusComponent } from './components/list-vehicle-bottom/fuel-status/fuel-status.component';
import { VehicleTextValueControlComponent } from './components/list-vehicle-bottom/vehicle-text-value-control/vehicle-text-value-control.component';
import { ControlsStatusComponent } from './components/list-vehicle-bottom/controls-status/controls-status.component';
import { LockStatusComponent } from './components/list-vehicle-bottom/lock-status/lock-status.component';
import { FilterControlComponent } from '@shared/components/vehicle-list/filter-control/filter-control.component';
import { TooltipModule } from 'primeng/tooltip';
import { TachoStatusFullListComponent } from './components/list-vehicle-bottom/tacho-status-full-list/tacho-status-full-list.component';
import { ListFullVehicleColumnConfigComponent } from './components/list-vehicle-bottom/list-full-vehicle-column-config/list-full-vehicle-column-config.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';

@NgModule({
  declarations: [
    MapComponent,
    MapMainLayerComponent,
    MapControlsComponent,
    IconComponent,
    MinimapControlsComponent,
    ModalWithParkInformationComponent,
    LoaderMapComponent,
    ModalEventInformationComponent,
    ListVehicleBottomComponent,
    CalculateTimeComponent,
    CalculateSpeedComponent,
    ETollStatusComponent,
    SingalStatusComponent,
    FuelStatusComponent,
    VehicleTextValueControlComponent,
    ControlsStatusComponent,
    LockStatusComponent,
    TachoStatusFullListComponent,
    ListFullVehicleColumnConfigComponent,
  ],
  imports: [
    CommonsModule,
    CommonModule,
    LeafletModule,
    TranslateModule,
    SharedModule,
    PipesModule,
    TableModule,
    SkeletonModule,
    ProgressBarModule,
    FilterControlComponent,
    TooltipModule,
    InputSwitchModule,
    FormsModule,
    ButtonModule,
  ],
  exports: [
    MapComponent,
    MapControlsComponent
  ],
  providers: [
    MapService
  ],

})
export class MapModule {
}
